import BurgerButton from "@/components/common-components/burger";
import AccountButtons from "@/components/account-buttons";
import { menuItems, menuItemsDesktop } from "./menuItems";
import ClickOutside from "vue-click-outside";

/**
 * NAVIGATION BAR
 *
 * The Navbar Component renders the main navigation for the site using the same
 * markup for large and small devices and requires no Javascript to browse
 * across dropdowns. To achieve that it uses hidden checkboxes as in many pure
 * CSS click Dropdown menus. This approach might be controversial ¯\_(ツ)_/¯
 *
 */
export default {
	name: "Navbar",
	components: {
		BurgerButton,
		AccountButtons,
	},
	data() {
		return {
			header: null,
			showSubMenu: false,
		};
	},
	computed: {
		menu() {
			if (this.$store.state.window.windowWidth === null) return [];
			return this.isExtraLargeDevice ? menuItemsDesktop : menuItems;
		},
		topIndent() {
			const adHeight = !this.isSmallDevice
				? this.$store.state.window.topAdHeight
				: 0;
			return (
				adHeight +
				this.$store.state.window.smartBannerHeight +
				this.$store.state.window.headerHeight
			);
		},
	},
	methods: {
		dispatchGaEvent(item) {
			const eventCategory = "Header";
			const eventLabel = item.gaEventLabel
				? item.gaEventLabel
				: item.labelDictionaryKey;
			const eventActionTranslation = item.gaEventAction
				? item.gaEventAction
				: this.$t(item.labelDictionaryKey);
			const eventAction = item.navLink
				? `Click on ${eventActionTranslation} navigation element`
				: `Click on ${eventActionTranslation} subnavigation element`;
			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory,
				eventAction: eventAction,
				eventLabel: eventLabel,
			});
		},
		toggleMenu() {
			if (!this.isExtraLargeDevice) return;
			this.showSubMenu = !this.showSubMenu;
			this.showSubMenu
				? this.header.classList.add("header-bg")
				: this.header.classList.remove("header-bg");
		},
		onItemClick(item) {
			if (item.submenu) {
				this.toggleMenu();
			}
			this.dispatchGaEvent(item);
		},
		onItemClickOutside(e) {
			if (["More", "menu2"].includes(e.target.id)) return;
			this.toggleMenu();
		},
	},
	mounted() {
		this.header = document.getElementsByClassName("header")[0];
	},
	directives: {
		ClickOutside,
	},
};
